import React, { forwardRef } from 'react';
import cx from 'classnames';

import { TextLink as TextLinkSBCRA } from '@motorway/motorway-storybook-cra';

import styles from './TextLink.module.scss';

interface TextLinkProps {
	classNames?: {
		container?: string;
		text?: string;
	};
	onClick?: () => void;
	onKeyPress?: () => void;
	tabIndex?: number;
	text?: string;
}

const TextLink: React.FC<TextLinkProps> = forwardRef(({ classNames = {}, ...props }, ref) => (
	<TextLinkSBCRA
		{...props}
		ref={ref}
		classNames={{
			container: cx(classNames.container, styles.textLink),
			text: classNames.text,
		}}
	/>
));

export default TextLink;
